import * as Yup from "yup";

const getNestedSchema = (
  parent = {},
  key = "",
  label,
  isRequired,
  validationSchema
) => {
  if (!(isRequired || validationSchema)) {
    return parent;
  }

  const keys = key.split(".");
  if (keys.length > 1) {
    const firstKey = keys.shift();
    return {
      ...parent,
      [firstKey]: getNestedSchema(
        parent[firstKey],
        keys.join("."),
        label,
        isRequired,
        validationSchema
      ),
    };
  }
  return {
    ...parent,
    [key]: validationSchema ?? Yup.string().required(`${label} is required`),
  };
};

const createValidationSchema = (obj) =>
  Object.entries(obj).reduce((res, [key, value]) => {
    if (!Yup.isSchema(value)) {
      return { ...res, [key]: Yup.object(createValidationSchema(value)) };
    }
    return { ...res, [key]: value };
  }, {});

const generateValidationSchema = (fieldsArray = []) => {
  const res = fieldsArray.reduce(
    (acc, { label, name, isRequired, validationSchema }) =>
      getNestedSchema(acc, name, label, isRequired, validationSchema),
    {}
  );

  return createValidationSchema(res);
};

export default generateValidationSchema;
